import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import { AppConfig } from '../app.config';
import { SessionService } from './session.service';
import { map, retry } from 'rxjs/operators';
import { Login } from '../_models/login';
import {DocumentSigningService} from "./document-signing.service";
import {Router} from "@angular/router";


@Injectable({
    providedIn: 'root'
  })
export class AuthenticactionService{
    private headers: any = {}

    constructor(
        private http: HttpClient,
        private config: AppConfig,
        private documentSigningService: DocumentSigningService,
        private router: Router,
        private sessionService: SessionService) {
        this.headers = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Authorization': 'Token token=' + this.config.API_TOKEN
            })
        }
    }


    // public login(login: Login, password:string): Observable<any>{
    //     let params = JSON.stringify({email: login.email, password: password});
    //     console.log(params)
    //     return this.http.post(this.config.BASE_API_URL + '/authenticate',params, this.headers)
    //         .pipe(
    //             map((response: any) => {
    //                 let data = response;
    //                 if (data.ed && this.config.isValidExternalRequest(data.ed)) {
    //                     this.session.setItem('user', JSON.parse(this.config.decryptLogin(data.ed)));
    //                 }
    //             })
    //             ,retry(1)
    //         );
    //         /* .subscribe(map((response: Response) => {
    //             let data = response.json();
    //             if (data['ed'] && this.config.isValidExternalRequest(data['ed'])) {
    //                 this.session.setItem('user', JSON.parse(this.config.decrypt(data['ed'])));
    //             }
    //         }).retry(1); */
    // }

    public login2(data){
        this.sessionService.setItem(AppConfig.ID_SESSION_TOKEN, data['login_token']);
        window.location.href = data['login_uri'];
    }

    public login3(data){
        this.sessionService.setItem(AppConfig.CLERK_DATA, data);
    }

    // public logout() {
    //     // remove user from local storage to log user out
    //     this.session.removeItem('user');
    //     this.session.removeItem('switched');
    // }

    private logout2() {
        if (this.sessionService.exist(AppConfig.ID_SESSION_TOKEN)){
            this.sessionService.removeItem(AppConfig.ID_SESSION_TOKEN);
        }
        if(this.sessionService.exist(AppConfig.CLERK_DATA)){
            this.sessionService.removeItem(AppConfig.CLERK_DATA);
        }
    }

    private async claveUnicaLogout(){
        window.location.href = this.config.LOGOUT_CLAVE_UNICA;
    }

    private async redirectToHome(){
        await this.router.navigate(['']);
    }

    public async logoutAll(need_clave_unica_logout = true){
        this.logout2();
        if (need_clave_unica_logout){await this.claveUnicaLogout();}
    }
}
